import React, {memo, useCallback, useEffect, useState} from "react"
import {ControlModel} from "../../../types/control"
import "./index.scss"
import minusIcon from "../../../assets/images/icons/controls/minus.png"
import plusIcon from "../../../assets/images/icons/controls/plus.png"
import fanCoilIcon from "../../../assets/images/icons/fancoil-menu.png"
import fan0 from "../../../assets/images/icons/fancoil-fan-a.png"
import fan1 from "../../../assets/images/icons/fancoil-fan-l.png"
import fan2 from "../../../assets/images/icons/fancoil-fan-m.png"
import fan3 from "../../../assets/images/icons/fancoil-fan-h.png"
import {Column} from "../../Column"
import {Widget} from "../../Widget"
import {onClickHandler} from "../../../utils/onclick"

type Props = {
    control: ControlModel
    homeValueTemperature: string
    valueTemperature: string
    temperatureClick: (isPlus: boolean) => void
    speedClick: (isPlus: boolean) => void
    valueSpeed: string
    clickOpenOff?: () => void
    clickHeatingMode?: () => void
    iconHeating: string
    iconOpenOff: string
    iconVentilate: string
    clickVentilate?: () => void
    buttonStatus?: boolean
}

export const FanCoilControlComponent = memo(function FanCoilControlComponent({
    control,
    valueTemperature,
    homeValueTemperature,
    temperatureClick,
    speedClick,
    valueSpeed,
    clickOpenOff,
    clickHeatingMode,
    iconHeating,
    iconOpenOff,
    iconVentilate,
    clickVentilate,
    buttonStatus
}: Props) {
    return (
        <Column min={6} max={12}>
            <Widget /*style={{marginTop: "3px", borderRadius: "3px", padding: "0.5rem"}}*/>
                <div className="position-relative">
                    <div className="fancoil-wrapper">
                        <div className="fancoil-top-box">
                            <div className="fancoil-img-box">
                                <img src={fanCoilIcon} alt="img" />
                            </div>
                            <span>{control.name}</span>
                        </div>
                        <div className="fancoil-content-box">
                            <div className="fancoil-content-left">
                                <button className={`fancoil-button`} {...onClickHandler(clickOpenOff)}>
                                    <img src={iconOpenOff} alt="img" />
                                </button>
                                <button className="fancoil-button" style={{visibility: "hidden"}}>
                                    <img src={iconHeating} alt="img" />
                                </button>
                                <button
                                    className={`fancoil-button`}
                                    {...onClickHandler(clickHeatingMode)}
                                    disabled={!buttonStatus && true}
                                >
                                    <img src={iconHeating} alt="img" />
                                </button>
                                <button
                                    className="fancoil-button"
                                    {...onClickHandler(clickVentilate)}
                                    disabled={!buttonStatus && true}
                                >
                                    <img src={iconVentilate} alt="img" />
                                </button>
                            </div>
                            <div className="fancoil-content-middle">
                                <span>
                                    {homeValueTemperature}
                                    <small>°</small>
                                </span>
                            </div>
                            <div className="fancoil-content-right">
                                <div className="fancoil-content-icon-box">
                                    <div className="fancoil-temp-box">
                                        <span>
                                            {valueTemperature}
                                            <small>°</small>
                                        </span>
                                    </div>
                                    <div className="fancoil-icon-box">
                                        <img src={valueSpeed} alt="img" />
                                    </div>
                                </div>
                                <div className="fancoil-content-button-box">
                                    <button
                                        className="fancoil-button"
                                        disabled={!buttonStatus && true}
                                        {...onClickHandler(() => temperatureClick(false))}
                                    >
                                        <img src={minusIcon} alt="img" />
                                    </button>
                                    <button
                                        className="fancoil-button"
                                        disabled={!buttonStatus && true}
                                        {...onClickHandler(() => temperatureClick(true))}
                                    >
                                        <img src={plusIcon} alt="img" />
                                    </button>
                                    <button
                                        className="fancoil-button"
                                        disabled={!buttonStatus && true}
                                        {...onClickHandler(() => speedClick(false))}
                                    >
                                        <img src={minusIcon} alt="img" />
                                    </button>
                                    <button
                                        className="fancoil-button"
                                        disabled={!buttonStatus && true}
                                        {...onClickHandler(() => speedClick(true))}
                                    >
                                        <img src={plusIcon} alt="img" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Widget>
        </Column>
    )
})
